"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash"); //🤢
var controllers_1 = require("@wix/social-groups-common/dist/src/controllers");
var types_1 = require("@wix/social-groups-api/dist/src/types");
var social_groups_api_1 = require("@wix/social-groups-api");
var GroupWrapper_1 = require("@wix/social-groups-api/dist/src/model/Group/GroupWrapper");
var loggers_1 = require("@wix/social-groups-common/dist/src/loggers");
var baseUrl_1 = require("@wix/social-groups-common/dist/src/baseUrl");
var wix_experiments_1 = require("@wix/wix-experiments");
var constants_1 = require("../../config/constants");
var UpdateProgress_1 = require("@wix/social-groups-common/dist/src/components/ContentEditor/UpdateProgress");
var GroupsStorage_1 = require("@wix/social-groups-common/dist/src/storage/GroupsStorage");
var MEMBERS_WITH_MY_APPROVAL = types_1.ApiTypes.v1.CreateGroupsPolicy.MEMBERS_WITH_MY_APPROVAL;
var BaseGroupsController = /** @class */ (function (_super) {
    tslib_1.__extends(BaseGroupsController, _super);
    function BaseGroupsController(controllerConfig, experiments) {
        if (experiments === void 0) { experiments = {}; }
        var _this = _super.call(this, controllerConfig) || this;
        _this.goToGroup = function (groupId) {
            _this.setState({ navigatingToGroup: groupId });
            if (_this.isEditorMode()) {
                _this.navigateInEditor(groupId);
            }
            else {
                var prefix = _this.getGroupPagePrefix();
                var groupToNavigate = _this.groupListModel.getGroupById(groupId);
                var tabToNavigate = 'discussion';
                if (groupToNavigate) {
                    var groupModel = new GroupWrapper_1.GroupWrapper(groupToNavigate);
                    if (!social_groups_api_1.isJoined(groupToNavigate) &&
                        groupModel.getPrivacy() !== types_1.ApiTypes.v1.GroupPrivacyLevel.PUBLIC) {
                        tabToNavigate = 'about';
                    }
                    _this.cacheGroup(groupToNavigate);
                }
                // Implementation note:
                // We are using location.to with argument pageURL#<corvid-element-id>,
                // where <corvid-element-id> is  an invalid id. So it would fallback to the same scroll position without a scroll to top.
                _this.wixCodeApi.location.to(prefix + "/" + groupId + "/" + tabToNavigate + "#preventScrollToTop");
            }
        };
        _this.createGroup = function (details, settings, image) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var group, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            isGroupCreating: true,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.groupModel.create(details, settings, image)];
                    case 2:
                        group = _a.sent();
                        this.setState({
                            groups: (this.state.groups || []).concat([group]),
                        });
                        this.cacheGroup(group);
                        this.goToGroup(group.slug);
                        if (this.state.createGroupPolicy === MEMBERS_WITH_MY_APPROVAL &&
                            !social_groups_api_1.isUserSiteAdmin(this.getCurrentUser())) {
                            this.platformAPIs.pubSub.publish(social_groups_api_1.APP_TOAST_EVENT, {
                                type: social_groups_api_1.AppToastTypes.GROUP_CREATED_IN_PENDING_STATE,
                                options: {
                                    'group-name': group.details.title,
                                },
                            }, false);
                            return [2 /*return*/];
                        }
                        this.platformAPIs.pubSub.publish(social_groups_api_1.APP_TOAST_EVENT, {
                            type: social_groups_api_1.AppToastTypes.GROUP_CREATED,
                            options: {
                                'group-name': group.details.title,
                            },
                        }, false);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        // TODO: handle error
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.setState({
                            isGroupCreating: false,
                        });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.handleGroupCardCTA = function (group) {
            var relationship = group.relationship, slug = group.slug;
            if (relationship === types_1.ApiTypes.v1.RelationshipWithGroup.JOINED) {
                _this.waitingJoinGroup = null;
                _this.goToGroup(slug);
                return Promise.resolve();
            }
            if (!_this.isUserLoggedIn()) {
                _this.waitingJoinGroup = group;
                return _this.promptLogin();
            }
            return _this.maybeChangeMembership(group);
        };
        _this.makeProfilePublic = function (siteMemberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var member, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.api.members.updateSiteMemberPrivacy(siteMemberId, social_groups_api_1.SiteMemberPrivacyStatus.PUBLIC)];
                    case 1:
                        member = (_a.sent()).data.member;
                        this.setState({
                            currentSiteMember: member,
                            promptPublicProfile: false,
                        });
                        if (!this.waitingJoinGroup) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.handleGroupCardCTA(this.waitingJoinGroup)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_2 = _a.sent();
                        console.error('Update site member profile: FAIL', e_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.submitAnswers = function (group, answers) {
            if (!answers) {
                return _this.rejectAnswers();
            }
            return _this.groupModel
                .joinGroup(group, answers)
                .then(function () {
                return _this.setGroups(_this.config);
            })
                .catch(function (e) {
                //TODO: handle error
                console.log('Error in BaseGroupsController.submitAnswers');
            })
                .finally(function () {
                _this.setState({ groupQuestions: null });
                _this.waitingJoinGroup = null;
            });
        };
        _this.rejectAnswers = function () {
            _this.waitingJoinGroup = null;
            _this.setState({ groupQuestions: null });
        };
        var appParams = controllerConfig.appParams, wixCodeApi = controllerConfig.wixCodeApi, platformAPIs = controllerConfig.platformAPIs, config = controllerConfig.config;
        _this.experiments = new wix_experiments_1.default({ experiments: experiments });
        _this.platformAPIs = platformAPIs;
        _this.wixCodeApi = wixCodeApi;
        _this.config = config;
        _this.initExternalServices(appParams.instance);
        _this.storage = GroupsStorage_1.GroupsStorage.fromControllerConfig(controllerConfig);
        _this.onUserLogin(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            updateProgress: UpdateProgress_1.UpdateProgress.UPDATING,
                            currentSiteMember: null,
                        });
                        this.initExternalServices(this.getSiteToken());
                        if (!this.waitingJoinGroup) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.handleGroupCardCTA(this.waitingJoinGroup)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.setGroups(this.config)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        return _this;
    }
    BaseGroupsController.prototype.updateConfig = function ($w, updatedConfig) {
        this.config = updatedConfig;
        return this.setGroups(updatedConfig);
    };
    BaseGroupsController.prototype.setGroups = function (config) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groups, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        groups = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getGroups(config)];
                    case 2:
                        groups = _a.sent();
                        this.cacheGroups(groups);
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        console.log('FAILED to get groups');
                        return [3 /*break*/, 4];
                    case 4:
                        this.setState({ groups: groups, updateProgress: UpdateProgress_1.UpdateProgress.STALE });
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseGroupsController.prototype.getGroupSectionUrl = function () {
        var prefix = this.getGroupPagePrefix();
        var baseUrl = this.wixCodeApi.location.baseUrl;
        return "" + baseUrl + prefix;
    };
    BaseGroupsController.prototype.navigateInEditor = function (groupId) {
        var compId = this.controllerConfig.compId;
        var section = {
            sectionId: 'group',
            noTransition: true,
            state: '',
            queryParams: { groupId: groupId },
            compId: compId,
        };
        if (typeof window === 'undefined') {
            return this.controllerConfig.wixCodeApi.location.navigateToSection(section);
        }
        return window.Wix.Utils.navigateToSection(section, console.error);
    };
    BaseGroupsController.prototype.cacheGroup = function (group) {
        this.storage.setGroup(group);
    };
    BaseGroupsController.prototype.cacheGroups = function (groups) {
        var _this = this;
        groups.forEach(function (g) { return _this.cacheGroup(g); });
    };
    BaseGroupsController.prototype.getGroupsInstanceSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.groupsInstanceSettings) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.fetchGroupsInstanceSettings()];
                    case 1:
                        _a.groupsInstanceSettings = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.groupsInstanceSettings];
                }
            });
        });
    };
    BaseGroupsController.prototype.fetchGroupsInstanceSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getGroupInstanceSettings()];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.settings];
                    case 2:
                        e_4 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_4);
                        return [2 /*return*/, {}];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BaseGroupsController.prototype.updateGroupInstanceSettings = function (settings) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var paths, requestData, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        paths = Object.keys(settings).map(function (key) {
                            return "settings." + lodash_1.snakeCase(key);
                        });
                        requestData = {
                            fieldMask: {
                                paths: paths,
                            },
                            settings: settings,
                        };
                        return [4 /*yield*/, this.api.updateGroupInstanceSettings(requestData)];
                    case 1:
                        data = (_a.sent()).data;
                        this.groupsInstanceSettings = data.settings;
                        return [2 /*return*/, this.groupsInstanceSettings];
                }
            });
        });
    };
    BaseGroupsController.prototype.pageReady = function ($w, wixAPI) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentSiteMember, groupsProps;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Props for SSR
                        this.setState({ actions: this.getActions() });
                        return [4 /*yield*/, this.getCurrentSiteMember()];
                    case 1:
                        currentSiteMember = _a.sent();
                        groupsProps = {
                            currentSiteMember: currentSiteMember,
                            navigatingToGroup: null,
                            updateProgress: UpdateProgress_1.UpdateProgress.STALE,
                        };
                        if (!this.isEditorMode()) {
                            groupsProps.groupSectionUrl = this.getGroupSectionUrl();
                        }
                        this.setState(groupsProps);
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    BaseGroupsController.prototype.getActions = function () {
        return {
            createGroup: this.createGroup,
            goToGroup: this.goToGroup,
            promptLogin: this.promptLogin.bind(this),
            handleGroupCardCTA: this.handleGroupCardCTA,
            makeProfilePublic: this.makeProfilePublic,
            submitAnswers: this.submitAnswers,
            rejectAnswers: this.rejectAnswers,
        };
    };
    BaseGroupsController.prototype.promptLogin = function () {
        var modal = this.experiments.enabled('specs.groups.PromptLoginModal');
        return _super.prototype.promptLogin.call(this, { modal: modal });
    };
    BaseGroupsController.prototype.withdrawJoinRequest = function (group) {
        // Need this because of refreshing `groupModel` in `this.initExternalServices`
        return this.groupModel.withdrawJoinRequest(group);
    };
    BaseGroupsController.prototype.joinGroup = function (group) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var questions, e_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.experiments.enabled('specs.groups.MembershipQuestions')) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.members.getMembershipQuestions(group.groupId)];
                    case 2:
                        questions = (_a.sent()).data.questions;
                        if (questions && questions.length) {
                            this.waitingJoinGroup = group;
                            this.setState({
                                groupQuestions: { group: group, questions: questions },
                            });
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_5 = _a.sent();
                        console.log('Error in BaseGroupsController.joinGroup');
                        return [3 /*break*/, 4];
                    case 4: 
                    // Need this because of refreshing `groupModel` in `this.initExternalServices`
                    return [2 /*return*/, this.groupModel.joinGroup(group)];
                }
            });
        });
    };
    BaseGroupsController.prototype.getGroupPagePrefix = function () {
        if (this.isEditorIframe()) {
            return '/group';
        }
        try {
            var siteStructure = this.wixCodeApi.site
                .getSiteStructure();
            var appDefinitionId_1 = this.controllerConfig.appParams.appDefinitionId;
            var groupPage = siteStructure.prefixes.find(function (page) {
                return page.applicationId === appDefinitionId_1 &&
                    page.name === constants_1.GROUP_PAGE_NAME;
            });
            return groupPage.prefix;
        }
        catch (e) {
            console.error('Get Group Page prefix: FAIL');
        }
        return '/group';
    };
    BaseGroupsController.prototype.isEditorIframe = function () {
        return this.isEditorMode() && typeof window !== 'undefined';
    };
    BaseGroupsController.prototype.initExternalServices = function (instance) {
        this.api = new social_groups_api_1.default(instance, baseUrl_1.default(this.wixCodeApi));
        this.groupModel = new social_groups_api_1.Group('', this.api, this.platformAPIs);
        this.groupListModel = new social_groups_api_1.GroupList(this.api);
    };
    BaseGroupsController.prototype.maybeChangeMembership = function (group) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentSiteMember, _a, e_6;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 12, , 13]);
                        return [4 /*yield*/, this.getCurrentSiteMember()];
                    case 1:
                        currentSiteMember = _b.sent();
                        if (!social_groups_api_1.isProfilePublic(currentSiteMember)) {
                            //prompt change
                            this.setState({ promptPublicProfile: true });
                            this.waitingJoinGroup = group;
                            return [2 /*return*/];
                        }
                        if (!(this.waitingJoinGroup !== null)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.fetchGroup(group.groupId)];
                    case 2:
                        group = _b.sent();
                        if (!social_groups_api_1.isNotMember(group)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.joinGroup(group)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        this.waitingJoinGroup = null;
                        return [2 /*return*/, this.setGroups(this.config)];
                    case 5:
                        _a = group.relationship;
                        switch (_a) {
                            case types_1.ApiTypes.v1.RelationshipWithGroup.PENDING_APPROVAL: return [3 /*break*/, 6];
                            case types_1.ApiTypes.v1.RelationshipWithGroup.REJECTED_MEMBERSHIP: return [3 /*break*/, 8];
                            case types_1.ApiTypes.v1.RelationshipWithGroup.NONE: return [3 /*break*/, 8];
                        }
                        return [3 /*break*/, 10];
                    case 6: return [4 /*yield*/, this.withdrawJoinRequest(group)];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 11];
                    case 8: return [4 /*yield*/, this.joinGroup(group)];
                    case 9:
                        _b.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        console.warn('Unknown relationship', group.relationship);
                        _b.label = 11;
                    case 11: return [3 /*break*/, 13];
                    case 12:
                        e_6 = _b.sent();
                        console.log('FAILED to change membership', e_6);
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/, this.setGroups(this.config)];
                }
            });
        });
    };
    BaseGroupsController.prototype.getCurrentSiteMember = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var member, e_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state.currentSiteMember) {
                            //TODO: where is state updated?
                            return [2 /*return*/, Promise.resolve(this.state.currentSiteMember)];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.members.getCurrentSiteMember()];
                    case 2:
                        member = (_a.sent()).data.member;
                        return [2 /*return*/, member];
                    case 3:
                        e_7 = _a.sent();
                        console.error('Get current site member profile: FAIL');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseGroupsController.prototype.fetchGroup = function (groupId) {
        var group = new social_groups_api_1.Group(groupId, this.api, this.platformAPIs);
        return group.fetch();
    };
    return BaseGroupsController;
}(controllers_1.BaseWidgetController));
exports.BaseGroupsController = BaseGroupsController;
//# sourceMappingURL=BaseGroupsController.js.map